import React from 'react';
import {_GPY} from '../../../env.js'
import GpyTime from './GpyTime.js';
import GpyToggleButton from './GpyToggleButton.js';
import GpyKeybindingButton from './GpyKeybindingButton.js';

class ScoreboardClock extends  React.Component {

	constructor(props) {
		super(props);

		this.state = {
			countdown : this.props.countdown!==undefined?this.props.countdown:false,
			defaultTimes : this.props.defaultTimes!==undefined? this.props.defaultTimes : [],
			adjustButtons : this.props.adjustButtons!==undefined? this.props.adjustButtons : [],
			clockname: this.props.clockName!==undefined?this.props.clockName:"gameclock",
			withOverlayButton: this.props.withOverlayButton!==undefined?this.props.withOverlayButton:false,
		}
	}

	componentDidMount() {
	}


  render () {
		let clockname = this.state.clockname;
    return (<>
					<div className="row">
				 				<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_'+clockname+'_title')}</strong></div>

									<div className="col-12 p-1">
										<GpyTime stateName={this.props.scoreboard.getName()+"_"+clockname} hidden="false" countdown={this.state.countdown} scoreboard={this.props.scoreboard}
												onTimerNull={(timer)=>{
													if(this.props.togglePlay!==undefined) { 
													 this.props.togglePlay("stop");
												 } else {
													 if(this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname]!==undefined) {
														 this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname].stop();
													 }
												 }
												 if(this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_button_start_stop_"+clockname]!==undefined) {
												 		this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_button_start_stop_"+clockname].onDeactivate();
											 	 }
										}}/>
									</div>

									<div className={this.state.withOverlayButton?"col-6 p-1":"col-12 p-1"}>
											<GpyToggleButton keyCode={clockname==="'gameclock"?this.props.startStopKeyCode:undefined} title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_'+clockname+'_button_start')}
												activeTitle={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_'+clockname+'_button_stop')}
												onDeactivate={() => {
													if(this.props.togglePlay!==undefined) { 
														this.props.togglePlay("stop");
													} else {
														if(this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname]!==undefined) {
															this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname].stop();
														}
													}
													return {}}}
												onActivate={() => {
													if(this.props.togglePlay!==undefined) { 
														this.props.togglePlay("start");
													} else {
														if(this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname]!==undefined) {
															this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_"+clockname].start();
														}
													}
													return {};
												}}
											scoreboard={this.props.scoreboard}
											getTime={()=>{return 0;}} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
											stateName={this.props.scoreboard.getName()+"_button_start_stop_"+clockname}
											/>
									</div>
									{this.state.withOverlayButton?
									<div className="col-6 p-1">
											<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_'+clockname+'_button_show')}
												activeTitle={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_'+clockname+'_button_show')}
												onDeactivate={() => {return {visible: false}}}
												onActivate={() => {
													return {visible: true};
												}}
											scoreboard={this.props.scoreboard}
											getTime={()=>{return 0;}} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
											stateName={this.props.scoreboard.getName()+"_button_start_show_"+clockname}
											/>
									</div>
									:<></>}
</div>
                     <div className="row">
											{this.state.defaultTimes.map((t)=>{
												return (
														<div key={this.props.scoreboard.getName()+"_"+clockname+"_timeset_"+t.time} className="col-3 p-1">
																<GpyKeybindingButton scoreboard={this.props.scoreboard} title={t.name}
																disabled={this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_'+clockname]!==undefined && this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_'+clockname].state.activeTimer}
																stateName={this.props.scoreboard.getName()+"_"+clockname+"_timeset_"+t.time}
																onClick={()=>{this.props.scoreboard.setGameTime(this.props.scoreboard.getName()+"_"+clockname,t.time)}}
																className="btn btn-secondary btn-sm btn-block"/>
														</div>
												);
											})}
										 </div>
										 <div className="row">
											{this.state.adjustButtons.map((t)=>{
												return (
														 <div key={this.props.scoreboard.getName()+"_"+clockname+"_time_adjust_"+t.time} className="col-2 p-1">
															 <GpyKeybindingButton scoreboard={this.props.scoreboard} title={t.name} className="btn btn-sm btn-block btn-light btn-outline-secondary"
																stateName={this.props.scoreboard.getName()+"_"+clockname+"_time_adjust_"+t.time}
																onClick={()=>this.props.scoreboard.adjustTimers(t.time)}
																/>
														</div>
												);
											})}
											</div>

		</>);
  }
}
export default ScoreboardClock;
